import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import mapColumnHeaders from 'common/components/ag-grid/mapColumnHeaders';

import { AgGridReact } from 'ag-grid-react';
import 'common/components/ag-grid/registerAgGridModules';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const AgGridClient = (props) => {
  const { containerStyle, refGrid, ...restProps } = props;

  const columnDefs = useMemo(
    () => mapColumnHeaders(restProps.columnDefs),
    [restProps.columnDefs]
  );

  const defaultColDef = {
    width: 170,
    sortable: true,
    filter: true,
    resizable: true,
  };

  const AgGridProps = {
    defaultColDef,
    headerHeight: 32,
    rowHeight: 32,
    ...restProps,
    columnDefs,
  };

  return (
    <div
      className='ag-theme-alpine ag-theme-alpine--with-scroller'
      style={containerStyle}
    >
      <AgGridReact theme="legacy" ref={refGrid} {...AgGridProps} />
    </div>
  );
};

AgGridClient.propTypes = {
  containerStyle: PropTypes.object,
};

AgGridClient.defaultProps = {
  containerStyle: {
    height: '100%',
    width: '100%',
  },
};

export default AgGridClient;
